import React from "react";
import {Shield3} from "@webng/icons-common";
import {Shield} from "react-feather";
import {useTranslation} from "react-i18next";
import { ApiImage } from "../ApiImage";
import {exactSizeImageUrl} from "@webng/liveblog";

export function EventTeamIconPlaceholder({className, name, length=1} : {className?:string, name?:string | undefined, length?:1|2|3} )  {
  const formatted_name = name ? name.replace(/\s+/g, '').substring(0, length) : '';

  return <div className={`tik4-ti-ph ${className}`}>
    { name
      ?
      <>
        <Shield3 className="tik4-ti-ph__svg" />
        <div className="tik4-ti-ph__i">{formatted_name}</div>
      </>
        :
        <Shield className="tik4-ti-ph__svg" />
    }
  </div>
}


export default function EventTeamIcon({className, placeholderClassName, image, name, size=32} : {className?:string, placeholderClassName?:string, image?:string, name?:string, size?:number}) {
  const {t} = useTranslation('liveblog');

  if (image) {
    // return <ApiImage className={className} src={teamImage.src.url} srcSet={teamImage.srcSet} height={teamImage.src.height} width={teamImage.src.width}/>
    // return <DprApiImage className={className} image={image} height={size} width={size} fit="contain" alt={t('liveblog.sport.scoreboard.img.alt', {name: name})}/>

  const image1x = exactSizeImageUrl(image, {width: size*1.5, height: size*1.5, fit: "contain", format: "webp"})
  const image2x = exactSizeImageUrl(image, {width: size*3, height: size*3, fit: "contain", format: "webp"})
  const image3x = exactSizeImageUrl(image, {width: size*4.5, height: size*4.5, fit: "contain", format: "webp"})
  const image4x = exactSizeImageUrl(image, {width: size*6, height: size*6, fit: "contain", format: "webp"})

    return <ApiImage 
    className={className} 
    src={image4x.url} 
    height={size} 
    width={size} 
    srcSet={`
    ${image4x.url} 4x, ${image3x.url} 3x, ${image2x.url} 2x, ${image1x.url} 1x`}
    alt={t('liveblog.sport.scoreboard.img.alt', {name: name})}/>
  } else {
    return <EventTeamIconPlaceholder className={placeholderClassName} name={name} />
  }

}
